import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {
    MvsApiCrudServiceCommentsInterface
} from "../../../../core/shared/service/api/mvs-api-crud-service-comments.interface";

@Injectable({
  providedIn: 'root'
})
export class ContractCommentService extends MvsCrudService implements MvsApiCrudServiceCommentsInterface {

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/cm/contractComments')
  }

  getCommentAttribute(): string {
    return "comment";
  }

  hasCommentPinOption(): boolean {
    return true;
  }


  getLinkedAttribute(objectType: string): string {
    if (objectType === "cm.Contract") {
      return "contract";
    }

    return null;
  }

}